import React from "react";
import PolicyPage from "@/components/PolicyPage";

export default function CerezPolitikasi() {
  return (
    <PolicyPage
      slug="cerez-politikasi"
      title="Çerez Politikası"
      intro="Abonelik İptal, web sitesi deneyimini iyileştirmek ve site kullanımını anlamak için çerezler kullanabilir. Bu politika hangi tür çerezleri kullanabileceğimizi açıklar."
      metaTitle="Çerez Politikası | Abonelik İptal"
      metaDescription="Abonelik İptal'te kullanılan çerez türleri, amaçları ve tercihlerinizi nasıl yönetebileceğinize dair bilgiler."
      sections={[
        {
          heading: "Çerez nedir?",
          body: [
            "Çerezler; ziyaret ettiğiniz web sitesinin tarayıcınızda küçük bir dosya olarak sakladığı, sonraki ziyaretlerde sitenin sizi hatırlamasını veya deneyiminizi geliştirmesini sağlayan metin dosyalarıdır.",
          ],
        },
        {
          heading: "Hangi çerezler kullanılabilir?",
          bullets: [
            "Zorunlu çerezler: sitenin temel çalışması, oturum ve güvenlik için gereklidir.",
            "Analitik çerezler: kullanıcıların sayfaları nasıl kullandığını anlamak ve iyileştirmeler yapmak için (ileride entegre edilebilir).",
            "Tercih çerezleri: tema, dil gibi tercihlerinizi hatırlamak için kullanılabilir.",
          ],
        },
        {
          heading: "Analitik çerezler için mevcut durum",
          body: [
            "Abonelik İptal, MVP aşamasında olduğu için henüz üçüncü taraf analitik araçlar aktif değildir. İleride site kullanımını anlamak için analitik araçlar entegre edilirse bu politikada güncelleme yapılacak ve kullanıcıya şeffaflıkla bildirilecektir.",
          ],
        },
        {
          heading: "Reklam veya pazarlama çerezleri",
          body: [
            "Abonelik İptal kullanıcı davranışını reklam veya pazarlama amaçlı takip etmez ve bu tür üçüncü taraf çerezleri site üzerinden yerleştirmez.",
          ],
        },
        {
          heading: "Tercihlerinizi yönetme",
          body: [
            "Tarayıcınızın ayarlar bölümünden çerez tercihlerinizi düzenleyebilir, mevcut çerezleri silebilirsiniz. Zorunlu çerezleri devre dışı bıraktığınızda sitenin bazı bölümleri düzgün çalışmayabilir.",
          ],
        },
        {
          heading: "İletişim",
          body: [
            "Çerez politikasıyla ilgili sorularınız için destek@abonelikiptal.com adresine e-posta gönderebilirsiniz.",
          ],
        },
      ]}
    />
  );
}
